<template>
  <div class="add-drawer">
    <div class="add-investigator">
      <el-checkbox-group v-model="currentType" class="mb-4">
        <el-checkbox-button v-for="item in types" :label="item" :key="item">{{ item }}</el-checkbox-button>
      </el-checkbox-group>
      <div v-if="currentType[0] === types[0]">
        <div class="title">上传文件</div>
        <div class="flex">
          <div class="import cursor-pointer" @click="onUploadFile" v-if="!file">
            <div class="el-icon-upload text-theme mt-6 mb-2 text-32"></div>
            <div>选择文件上传</div>
            <div class="text-small text-theme-text-gray">文件大小不超过20M</div>
          </div>
          <div class="import" v-else>
            <div class="mt-14">
              <span>{{ file.name }}</span>
              <el-tag size="small" class="mx-2">{{ totalCount }} 个样本数据</el-tag>
              <i class="el-icon-close cursor-pointer" @click="clearFile"></i>
            </div>
          </div>
          <div class="w-2/6 text-center pt-10">
            为了保证数据导入顺利，推荐您下载使用<span class="text-theme cursor-pointer" @click="downloadTemplate">导入模板</span
            >，并按照规范示例录入数据。
          </div>
        </div>
        <div v-if="file">
          <div class="title mt-6">数据预览</div>
          <div class="table-item">
            <span class="w-1/5 text-theme-black-650">样本属性字段</span
            ><span class="w-4/5 text-theme-black-650">第 1 个样本</span>
          </div>
          <div class="table-item" v-for="(item, index) in tableData" :key="index">
            <span class="w-1/5">{{ item.field }}</span
            ><span class="w-4/5">{{ item.value }}</span>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="title">调查员信息</div>
        <iframe id="iframe" class="iframe" :src="url" v-if="iframeFlag"></iframe>
      </div>

      <div v-if="tableLength !== 0">
        <div class="title mt-6">调查员数据更新规则</div>
        <div class="mb-6">一个手机号对应一个调查员</div>
        <div class="flex mb-4">
          <div class="mr-4 leading-24">同一调查员，调查员已有值，导入值为空时</div>
          <el-radio-group v-model="nullValueRule" class="mt-1" @change="changeRule">
            <el-radio :label="0">使用导入值</el-radio>
            <el-radio :label="1">保留已有值</el-radio>
          </el-radio-group>
        </div>
        <div class="flex mb-4">
          <div class="mr-4 leading-24">同一调查员，调查员已有值，但和导入值不相同时</div>
          <el-radio-group v-model="differentValueRule" class="mt-1" @change="changeRule">
            <el-radio :label="0">使用导入值</el-radio>
            <el-radio :label="1">保留已有值</el-radio>
          </el-radio-group>
        </div>
      </div>
    </div>
    <div class="footer-btn">
      <el-button v-if="currentType[0] !== types[0]" @click="addInvestigator('once')">添加</el-button>
      <el-button type="primary" v-if="currentType[0] !== types[0]" @click="addInvestigator('continue')">保存并继续添加</el-button>
      <el-button type="primary" v-else @click="importInvestigators">导入调查员</el-button>
    </div>
  </div>
</template>

<script>
import GlobalConfig from '@/global/config'
import { getFreeLink } from '@/api/wenjuan/publish'
import { detail } from '@/api/wenjuan/answerList'
import { uploadFile, UploadConfig } from '@dygc/shared'
import {
  downloadTemplate,
  importInvestigator,
  addorUpdateWjInvestigator,
  updateOrSaveSyncById,
  getInvestigatorSync
} from '@/api/more-app/investigator-base'
import { getSurveyDomain } from '@/assets/js/config/env'

export default {
  name: 'InvestigatorAddDrawer',
  props: {
    isAdmin: {
      type: Boolean,
      default: true
    },
    tableLength: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      currentType: ['文件导入'],
      types: ['文件导入', '手动添加'],
      differentValueRule: 0,
      nullValueRule: 1,
      totalCount: 0,
      tableData: [],
      file: null,
      answerChannelId: '',
      url: '',
      answerId: '',
      answerContent: [],
      iframeFlag: true,
      submitFlag: true,
      addType: '',
      num: 0
    }
  },
  watch: {
    currentType(val) {
      if (val.length === 2) this.currentType.shift()
    }
  },
  methods: {
    // 调查员数据更新规则
    changeRule(val) {
      let data = {
        surveyId: GlobalConfig.getSurveyId(),
        syncImportNull: this.nullValueRule,
        syncImportDiff: this.differentValueRule
      }
      updateOrSaveSyncById(data)
        .then(res => {
          if (res.data.code !== 0) return
          this.$message.success('更新规则设置成功')
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 添加调查员
    addInvestigator(type) {
      this.addType = type
      // 向答题页面发送消息，获取answerId
      const answer = document.getElementById('iframe')
      if (answer) {
        window.addEventListener('message', this.addInvestigatorFunction)
        answer.contentWindow.postMessage('submit', '*')
      }
    },
    // 添加调查员后续调用的方法
    async addInvestigatorFunction(evt) {
      window.removeEventListener('message', this.addInvestigatorFunction)
      if (typeof evt.data === 'object' || JSON.parse(evt.data).message !== 'answerOver') return
      // 用来限制单次添加调查员
      if (this.num > 0 && this.addType === 'once') {
        return
      } else if (this.addType === 'once') {
        this.num++
      }

      // 用来代表已经提交答卷
      let data = JSON.parse(evt.data)
      if (data.message !== 'answerOver') return

      // 用来限制连续添加调查员
      if (!this.submitFlag) return
      this.submitFlag = false
      if (this.answerId === data.payload.answerId) return

      // console.log("%c 接收到的数据为：%o","color:blue",evt.data)
      this.answerId = data.payload.answerId
      await detail(this.answerId)
        .then(res => {
          if (res.data.code !== 0) return
          this.answerContent = res.data.data.answerContent
        })
        .catch(err => {
          console.log(err)
        })
      let params = {
        differentValueRule: this.differentValueRule,
        nullValueRule: this.nullValueRule,
        surveyId: GlobalConfig.getSurveyId(),
        recordSource: 1,
        answerId: this.answerId,
        investigatorName: this.answerContent[0].items[0].value,
        investigatorPhone: this.answerContent[1].items[0].value
      }
      await addorUpdateWjInvestigator(params)
        .then(res => {
          if (res.data.code !== 0) return
          this.$message.success('添加成功')
          this.url = ''
          this.getUrl()
          if (this.addType === 'once') this.$emit('close-drawer')
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          this.answerId = ''
          // 恢复连续添加的开关
          setTimeout(() => {
            this.submitFlag = true
          }, 2000)
        })
    },
    // 下载模板
    downloadTemplate() {
      downloadTemplate({ surveyId: GlobalConfig.getSurveyId() })
        .then(res => {
          if (res.data.code !== 0) return
          window.open(res.data.data)
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 导入文件
    onUploadFile() {
      uploadFile(UploadConfig.LARGE_SIZE, ['xlsx', 'xls'])
        .then(file => {
          import('xlsx').then(Xlsx => {
            let reader = new FileReader()
            reader.onload = () => {
              let workbook = Xlsx.read(reader.result, {
                type: 'binary',
                cellDates: true
              })
              this.createSampleData(this.readWorkBook(workbook))
            }
            reader.readAsBinaryString(file)
            this.file = file
          })
        })
        .catch(err => {
          this.$message.error(err.msg)
        })
    },
    readWorkBook(workbook) {
      // 读取第一个sheet
      let sheet = workbook.Sheets[workbook.SheetNames[0]]
      const reg = /([A-Z])(\d+)/
      // 获取起始位置 和 结束位置
      let [s, e] = sheet['!ref'].split(':')
      let se = reg.exec(s)
      let ee = reg.exec(e)
      let sc = se[1].charCodeAt()
      let ec = ee[1].charCodeAt()
      let labelIndex = Number(se[2])
      let lastIndex = Number(ee[2])

      // 获取所有列对于的字母
      const keys = []
      while (sc <= ec) {
        keys.push(String.fromCharCode(sc))
        sc++
      }
      while (labelIndex < lastIndex) {
        let flag = keys.every(k => sheet[k + labelIndex])
        if (flag) {
          break
        }
        labelIndex++
      }
      while (labelIndex < lastIndex) {
        let flag = keys.some(k => sheet[k + lastIndex])
        if (flag) {
          break
        }
        lastIndex--
      }
      if (labelIndex === lastIndex) {
        return []
      }
      this.totalCount = lastIndex - labelIndex
      const result = []
      keys.forEach(key => {
        let idx = labelIndex
        const item = {
          label: sheet[key + idx].v,
          values: []
        }
        idx++
        while (idx <= lastIndex) {
          let val = (sheet[key + idx] || { v: '' }).v
          if (val instanceof Date) {
            val.setTime(val.getTime() + 1000 * 60)
            let y = val.getFullYear()
            let m = val.getMonth() + 1
            let d = val.getDate()
            val = `${y}-${m}-${d}`
          }
          item.values.push(val)
          idx++
        }
        result.push(item)
      })
      return result
    },
    createSampleData(results = []) {
      if (!results.length) {
        this.tableData = []
        return
      }
      this.tableData = results.map(item => {
        return {
          field: item.label,
          value: item.values[0]
        }
      })
    },
    // 清除文件
    clearFile() {
      this.file = null
      this.tableData = []
    },
    // 根据模板导入调查员
    importInvestigators() {
      if (!this.file) {
        this.$message.error('请上传文件')
        return
      }
      let params = {
        updateWhenOldIsDifferent: this.differentValueRule,
        cleanWhenNewIsEmpty: this.nullValueRule,
        surveyId: GlobalConfig.getSurveyId()
      }
      let data = new FormData()
      data.append('file', this.file)
      importInvestigator(params, data)
        .then(res => {
          if (res.data.code !== 0) {
            this.$message.error(res.data.msg)
            return
          }
          let data = res.data.data
          if (data.successCount === 0) {
            this.$message.error(`导入失败，请查看原因`)
          } else {
            this.$message.success(`成功导入${data.successCount}条数据`)
          }
          if (data.errFilePath !== null) {
            window.open(data.errFilePath)
          }
          this.$emit('close-drawer')
        })
        .catch(err => {
          console.log(err)
        })
    },
    async getUrl() {
      const surveyId = GlobalConfig.getSurveyId()
      const params = {
        channelType: '0',
        surveyId
      }
      const {
        data: { data }
      } = await getFreeLink(params)
      this.answerChannelId = data[0].id
      const origin = getSurveyDomain()
      const tenantId = GlobalConfig.getTenantId()
      const token = GlobalConfig.getToken()
      this.url = `${origin}/pc/index.html?surveyId=${surveyId}&answerChannelId=${
        this.answerChannelId
      }&token=${token}&tenantId=${tenantId}&companyid=${GlobalConfig.getCompanyId()}&answerType=investigatorAdd&disableSubmit=true`
    },
    // 获取更新规则
    getInvestigator() {
      getInvestigatorSync()
        .then(res => {
          if (res.data.code !== 0) return
          this.nullValueRule = res.data.data.syncImportNull
          this.differentValueRule = res.data.data.syncImportDiff
        })
        .catch(err => {
          console.log(err)
        })
    }
  },
  created() {
    this.getUrl()
    this.getInvestigator()
  }
}
</script>

<style scoped lang="scss">
.add-drawer {
  @apply leading-22 text-theme-black-850 h-full;
  .iframe {
    width: 100%;
    height: calc(100vh - 237px);
  }
  .add-investigator {
    height: calc(100% - 97px);
    @apply p-4 overflow-auto;
  }
  .title {
    @apply text-medium-x font-semibold mb-4;
  }
  .import {
    @apply w-1/2 h-36 rounded-lg bg-theme-gray border border-theme border-dashed mr-6 text-center;
  }
  .table-item {
    @apply text-medium w-full flex border-b border-solid border-border-gray;
    span {
      @apply px-4 leading-22 py-3;
    }
  }
  .footer-btn {
    @apply w-full text-right bottom-0 right-0 py-4 px-6 bg-white border-t border-solid border-border-gray box-border;
  }
  ::v-deep .el-radio__label {
    @apply text-medium-x;
  }
}
</style>
